var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RudderstackSink } from './sinks/rudderstack-sink';
import { FullstorySink } from './sinks/fullstory-sink';
import { ConsoleSink } from './sinks/console-sink';
import config from '../../../../config';
var EngageTracker = /** @class */ (function () {
    function EngageTracker() {
        this.sinks = [];
        this.context = {};
        this.sinksInitialized = false;
        this.initializeDefaultSinks();
    }
    EngageTracker.getInstance = function () {
        if (!EngageTracker.instance) {
            EngageTracker.instance = new EngageTracker();
        }
        return EngageTracker.instance;
    };
    EngageTracker.prototype.initializeDefaultSinks = function () {
        if (this.sinksInitialized) {
            return;
        }
        if (config.deploymentEnv === 'local' || !config.deploymentEnv) {
            this.addSink(new ConsoleSink());
        }
        this.addSink(new RudderstackSink());
        this.addSink(new FullstorySink());
        this.sinksInitialized = true;
    };
    EngageTracker.prototype.addSink = function (sink) {
        var sinkExists = this.sinks.some(function (s) { return s.constructor.name === sink.constructor.name; });
        if (!sinkExists) {
            this.sinks.push(sink);
        }
    };
    EngageTracker.prototype.removeSink = function (sink) {
        this.sinks = this.sinks.filter(function (s) { return s !== sink; });
    };
    EngageTracker.prototype.setContext = function (context) {
        this.context = __assign({}, context);
    };
    EngageTracker.prototype.track = function (event, properties) {
        var payload = __assign(__assign({}, this.context), (properties || {}));
        this.sinks.forEach(function (sink) { return sink.track(event, payload); });
    };
    EngageTracker.instance = null;
    return EngageTracker;
}());
export { EngageTracker };
